import React from 'react';

import DataReportTable from '../components/data-report/table';

class DataReportPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<DataReportTable />
			</div>
		)
	}

}

export default DataReportPage;


// WEBPACK FOOTER //
// ./src/containers/data-report-page.js